import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import FetchApi from '../customhooks/functionFetchApi';

const Quaritygroup = () => {
  const FetchApis = new FetchApi();
  const [form, setForm] = useState({ namegroup: '', remarkdetail: '', actives: false, Id: '' });
  const [groups, setGroups] = useState([]);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    FetchApis.FethcGet(`/quarity/getAllTdsGroupQuarity`).then((res) => {
      console.log('Fetch group quarity:', res.data.data);
      if (res && res.data) {
        const items = Array.isArray(res.data.data) ? res.data.data : [];
        setGroups(items.map((item) => ({
          id: item.gId,
          namegroup: item.namegroup || '',
          remarkdetail: item.remarkdetail || '',
          actives: item.actives === 1 || item.actives === true || item.actives === '1',
          raw: item,
        })));
      }
    })
  }, [])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  }

  const resetForm = () => {
    setForm({ namegroup: '', remarkdetail: '', actives: false, Id: '' });
    setEditId(null);
  }

  const handleSubmit = (e) => {
    // e.preventDefault();

    if (!form.namegroup.trim()) return;

    if (editId) {

      FetchApis.FethcUpdate(`/quarity/UpdatetdsGroupQuarity/${form.Id}`, {
        namegroup: form.namegroup,
        remarkdetail: form.remarkdetail,
        actives: form.actives ? 1 : 0,
      }).then((res) => {

        console.log('Update group quarity:', res);
        setGroups((prev) => prev.map((item) => item.id === editId ? {
          ...item,
          namegroup: form.namegroup,
          remarkdetail: form.remarkdetail,
          actives: form.actives,
        } : item));
     
      });

      resetForm();
      return;
    }

    const newItem = {
      id: Date.now() + Math.random(),
      namegroup: form.namegroup,
      remarkdetail: form.remarkdetail,
      actives: form.actives,
    };

    setGroups((prev) => [newItem, ...prev]);
    FetchApis.FethcPost(`/quarity/CreatetdsGroupQuarity`, {
      namegroup: form.namegroup,
      remarkdetail: form.remarkdetail,
      actives: form.actives ? 1 : 0,
    }).then((res) => {
      console.log('Create group quarity:', res);
    });

    resetForm();
  }

  const handleEdit = (row) => {
    console.log('Edit group quarity:', row);
    setForm({
      namegroup: row.namegroup,
      remarkdetail: row.remarkdetail,
      actives: !!row.actives,
      Id: row.id,
    });

    setEditId(row.id);

  }

  const handleDelete = (rowId) => {
    console.log('Delete group quarity:', rowId.id);
    if (window.confirm('ลบกลุ่มคุณภาพนี้?')) {
      FetchApis.FethcDelete(`/quarity/DeletetdsGroupQuarity/${rowId.id}`).then((res) => {
        console.log('Delete group quarity:', res);
      });

      setGroups((prev) => prev.filter((item) => item.id !== rowId.id));
    }
    if (editId === rowId) {
       resetForm();
    }

  }

  const handleAddManager = (row) => {
    window.location.href = `/Quraityapproved/${row.id}`;
  }

 

  const columns = [
    {
      name: 'namegroup',
      selector: (row) => row.namegroup,
      sortable: true,
      grow: 2,
    },
    {
      name: 'remarkdetail',
      selector: (row) => row.remarkdetail,
      sortable: true,
      grow: 3,
    },
    {
      name: 'actives',
      selector: (row) => row.actives ? 'ใช้งาน' : 'ไม่ใช้งาน',
      sortable: true,
      grow: 1,
    },
    {
      name: 'จัดการ',
      cell: (row) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            type="button"
            onClick={() => handleEdit(row)}
            style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #1976d2', background: '#1976d2', color: '#fff', cursor: 'pointer' }}
          >
            แก้ไข
          </button>
          <button
            type="button"
            onClick={() => handleAddManager(row)}
            style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #1e7e34', background: '#1e7e34', color: '#fff', cursor: 'pointer' }}
          >
            เพิ่มผู้จัดการ
          </button>
          <button
            type="button"
            onClick={() => handleDelete(row)}
            style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #e53935', background: '#fff', color: '#e53935', cursor: 'pointer' }}
          >
            ลบ {row.gId}
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '280px',
    },
  ];


  return (
    <div style={{ padding: '20px', maxWidth: '920px' }}>
      <h2>Group Quarity </h2>

      <form onSubmit={handleSubmit} style={{ marginBottom: '24px', display: 'grid', gap: '16px' }}>
        <div style={{ display: 'grid', gap: '8px' }}>
          <label htmlFor="namegroup">name group</label>
          <input
            id="namegroup"
            name="namegroup"
            value={form.namegroup}
            onChange={handleChange}
            placeholder="กรอกชื่อกลุ่ม"
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>

        <div style={{ display: 'grid', gap: '8px' }}>
          <label htmlFor="remarkdetail">remark detail</label>
          <input
            id="remarkdetail"
            name="remarkdetail"
            value={form.remarkdetail}
            onChange={handleChange}
            placeholder="กรอกหมายเหตุ"
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <input
            id="actives"
            name="actives"
            type="checkbox"
            checked={form.actives}
            onChange={handleChange}
          />
          <label htmlFor="actives">ใช้งาน</label>
        </div>

        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <button
            type="submit"
            style={{ width: '160px', padding: '10px 14px', borderRadius: '4px', background: '#1976d2', color: '#fff', border: 'none', cursor: 'pointer' }}
          >
            {editId ? 'อัปเดต' : 'บันทึก'}
          </button>
          {editId && (
            <button
              type="button"
              onClick={resetForm}
              style={{ padding: '10px 14px', borderRadius: '4px', background: '#f5f5f5', color: '#333', border: '1px solid #ccc', cursor: 'pointer' }}
            >
              ยกเลิก
            </button>
          )}
        </div>
      </form>

      <div>
        <h3>รายการ Group Quarity</h3>
        <DataTable
          columns={columns}
          data={groups}
          noHeader
          responsive
          pagination
          highlightOnHover
          pointerOnHover
          dense
          striped
          noDataComponent={<div style={{ padding: '16px' }}>ยังไม่มีรายการ</div>}
        />
      </div>
    </div>
  )
}

export default Quaritygroup
